export default class FacilityTechnicalStateWrapper {
  technicalInfoDto = {};
  facilityStateDto = {};

  constructor() {
  }
}